import React, { createContext, useContext, useState, useEffect } from 'react';
import { login as loginService, logout as logoutService, getCurrentUser, isAuthenticated } from '../services/auth';

const AuthContext = createContext();

export const useAuth = () => {
  const context = useContext(AuthContext);
  if (!context) {
    throw new Error('useAuth must be used within AuthProvider');
  }
  return context;
};

export const AuthProvider = ({ children }) => {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);
  const [selectedBranchId, setSelectedBranchId] = useState(localStorage.getItem('branch_id') || 'all');
  const [branches, setBranches] = useState([]);

  useEffect(() => {
    // Check if user is logged in on mount
    if (isAuthenticated()) {
      const savedUser = getCurrentUser();
      if (savedUser) {
        setUser(savedUser);
        // If not an owner and has a branch, force that branch
        if (savedUser.role !== 'owner' && savedUser.role !== 'admin' && savedUser.branch_id) {
          setSelectedBranchId(savedUser.branch_id.toString());
          localStorage.setItem('branch_id', savedUser.branch_id.toString());
        }
      }
    }
    setLoading(false);
  }, []);

  const switchBranch = (branchId) => {
    setSelectedBranchId(branchId);
    if (branchId === 'all') {
      localStorage.removeItem('branch_id');
    } else {
      localStorage.setItem('branch_id', branchId);
    }
  };

  const login = async (username, password) => {
    try {
      const response = await loginService(username, password);
      setUser(response.user || getCurrentUser());
      return response;
    } catch (error) {
      throw error;
    }
  };

  const logout = async () => {
    try {
      await logoutService();
      setUser(null);
    } catch (error) {
      // Even if logout fails, clear local state
      setUser(null);
      throw error;
    }
  };

  const value = {
    user,
    login,
    logout,
    loading,
    selectedBranchId,
    setSelectedBranchId: switchBranch,
    isOwner: user?.role === 'owner' ||
      user?.role === 'admin' ||
      user?.role_name?.toLowerCase() === 'owner' ||
      user?.role_name?.toLowerCase() === 'admin' ||
      user?.role_name === 'ئەدمین' ||
      user?.role_name === 'خاوەن' ||
      user?.role_name === 'خاوەن کۆمپانیا',
    isAuthenticated: isAuthenticated()
  };

  return (
    <AuthContext.Provider value={value}>
      {children}
    </AuthContext.Provider>
  );
};

